@mixin circle {
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
}

.arrowImage {
  margin: auto;
}

.link {
  @include circle;
  background-color: var(--blue-01);
}

.link:hover {
  background-color: var(--blue-01);
}

.disabled {
  @include circle;
  background-color: var(--black-at-75);
}

.leftArrow {
  padding-left: 3px;
}

.rightArrow {
  padding-right: 3px;
}
